module.exports = __webpack_public_path__ + "static/media/bgcourse-3.7c83e7e7.jpg";